import { translate } from 'i18n/i18n'
import { isNil } from 'lodash'
import { getInsectNameFromId } from 'utils/getInsectNameFromId'
import type { TUnitConverterTypicalReturn } from '../types'

const DEFAULT_DECIMAL_PLACES = 1

const makeTrapCatchesUnitConverter = (isPercentSeries = false) => {
  const trapCatches = (
    numberOfCatches: number | null = null,
    {
      insectId = -1,
      decimalPlaces = DEFAULT_DECIMAL_PLACES,
    }: {
      insectId?: number
      decimalPlaces?: number
    } = {},
  ): TUnitConverterTypicalReturn => {
    let convertedValue: number | null

    if (isNil(numberOfCatches)) {
      convertedValue = null
    } else {
      convertedValue = Number(numberOfCatches)
    }

    const title = translate.phrases.banyanApp('{{insectName}} Trap Catches', {
      insectName: getInsectNameFromId(insectId),
    })

    return {
      categoryTitle: () => translate.phrases.banyanApp('Trap Catches'),
      categoryTitleWithoutUnit: () => translate.phrases.banyanApp('Trap Catches'),
      defaultNumberOfDecimalPlaces: () => DEFAULT_DECIMAL_PLACES,
      suffix: () => (isPercentSeries ? translate.phrases.unitSymbols('%') : ''),
      shortTitle: () => {
        return title
      },
      title: () => {
        return title
      },
      titleWithoutUnit: () => {
        return title
      },
      value: () => {
        if (isNil(convertedValue)) return null

        return +convertedValue?.toFixed(decimalPlaces)
      },
      valueAsString: () => `${convertedValue?.toFixed(decimalPlaces) ?? translate.phrases.templates('-')}`,
      valueWithSuffix: () => {
        if (isNil(convertedValue)) return translate.phrases.templates('-')

        if (isPercentSeries) {
          return translate.measurements.percentage.valueWithUnit(convertedValue, decimalPlaces)
        }

        return convertedValue.toFixed(decimalPlaces)
      },
      valueWithNoRounding: () => convertedValue,
    }
  }

  return trapCatches
}

export const insectTrapCatches = {
  insectTrapCatches: makeTrapCatchesUnitConverter(),
  insectTrapCatchesPercentage: makeTrapCatchesUnitConverter(true),
}
